import React from 'react';
import BaseCard, { EcmBaseCardProps } from './BaseCard';
import styles from './../CardsList.module.less';

export type EcmImageCardProps = EcmBaseCardProps & {
  image?: string;
};

type ImageCardProps = {
  ecmContent: EcmImageCardProps;
};

const ImageCard: React.FC<ImageCardProps> = ({ ecmContent }) => {
  const { image, title } = ecmContent;

  return (
    <div>
      {image && <img src={image} alt={title} className={styles.card_image} />}
      <BaseCard ecmContent={ecmContent} />
    </div>
  );
};

export default ImageCard;
